var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoteMultiOn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 25.88,
    viewBox: "0 -0.94 24 25.88",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.382 17.607V.535H7.733v1.643l-3.726.524.242 1.722-3.63 1.041 4.706 16.41 14.495-4.156.794-.111zM9.155 1.958h12.804v14.226H9.155zM7.733 3.48v14.127h3.618l-3.87.544L5.463 3.799zM6.208 20.281 2.214 6.349l2.216-.635 1.953 13.894 4.263-.599z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.903 7.061-5.121 5.121h-1.897v-1.897l5.121-5.121zm.64-.641-1.897-1.897.665-.665a.57.57 0 0 1 .805 0l1.092 1.092a.57.57 0 0 1 0 .805zm-1.588 3.338v3.94h-7.586V6.112h4.173l1.517-1.517H10.99c-.626 0-1.138.512-1.138 1.138v8.345c0 .626.512 1.138 1.138 1.138h8.345c.626 0 1.138-.512 1.138-1.138V8.396z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "red"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.571 23.304h7.596v1.391H.571zM15.953 23.304h7.596v1.391h-7.596zM11.212 23.304h1.911v1.391h-1.911z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoteMultiOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/note-multi-on.svg";